export default "__VITE_ASSET__BtEOTEj5__"